import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute";
import PublicRoute from "components/PublicRoute";
import IndividualEnroll from "pages/signUp/individual/IndividualEnroll";
import IndividualDisclosure from "pages/signUp/individual/IndividualDisclosure";
import IndividualInvestmentProfile from "pages/signUp/individual/IndividualInvestmentProfile";
import IndividualTerms from "pages/signUp/individual/IndividualTerms";
import IndividualThanks from "pages/signUp/individual/IndividualThanks";
import IndividualPortfolioSelection from "pages/signUp/individual/IndividualPortfolioSelection";
import IndividualAccountType from "../pages/signUp/individual/IndividualAccountType";
import IndividualDocsRequired from "pages/signUp/individual/IndividualDocsRequired";
import IndividualDenied from "pages/signUp/individual/IndividualDenied";
import IndividualOptOut from "pages/IndividualOptOut";
import VerifyEmail from "pages/signUp/VerifyEmail";
import DashboardLayout from "pages/dashboards/DashboardLayout";
import EmailVerification from "pages/verification/EmailVerification";
import EmailVerificationRedirect from "pages/verification/EmailVerificationRedirect";
import IndividualLogin from "pages/IndividualLogin";
import SetupContribution from "pages/signUp/individual/setupContribution/SetupContribution";
import PageNotFound from "pages/PageNotFound";
import { useMediaQuery } from "react-responsive";
import OauthPlaidLink from "../pages/OauthPlaidLink";
import IndividualRequiredUpdates from "../pages/dashboards/individualDashboard/requiredUpdates/IndividualRequiredUpdates";
import { useDashboardRoutes } from "hooks/useDashboardRoutes";
import { renderDashboardRoutes } from "routes/renderDashboardRoutes";

const IndividualDashboardLayout = () => {
  const isSmallScreen = useMediaQuery({ maxWidth: 767 });
  const routes = useDashboardRoutes({ isEmployerDashboard: false });
  return (
    <DashboardLayout
      isEmployerDashboard={false}
      isSmallScreen={isSmallScreen}
      routes={routes}
    />
  );
};

const IndividualRoutes = () => {
  const dashboardRoutes = useDashboardRoutes({ isEmployerDashboard: false });
  return (
    <Routes>
      <Route path="/" element={<PublicRoute path="/" />} />
      <Route
        path="/individual/opt-out"
        element={
          <PublicRoute
            path="/individual/opt-out"
            component={IndividualOptOut}
          />
        }
      />
      <Route
        path="/individual/verify"
        element={
          <PrivateRoute path="/individual/verify" component={VerifyEmail} />
        }
      />
      <Route
        path="/individual/info"
        element={
          <PrivateRoute path="/individual/info" component={IndividualEnroll} />
        }
      />
      <Route
        path="/individual/investment"
        element={
          <PrivateRoute
            path="/individual/investment"
            component={IndividualInvestmentProfile}
          />
        }
      />
      <Route
        path="/required-updates"
        element={
          <PrivateRoute
            path="/required-updates"
            component={IndividualRequiredUpdates}
          />
        }
      />
      <Route
        path="/individual/disclosure"
        element={
          <PrivateRoute
            path="/individual/disclosure"
            component={IndividualDisclosure}
          />
        }
      />
      <Route
        path="/individual/terms"
        element={
          <PrivateRoute path="/individual/terms" component={IndividualTerms} />
        }
      />
      <Route
        path="/individual/thanks"
        element={
          <PrivateRoute
            path="/individual/thanks"
            component={IndividualThanks}
          />
        }
      />
      <Route
        path="/individual/portfolio_selection"
        element={
          <PrivateRoute
            path="/individual/portfolio_selection"
            component={IndividualPortfolioSelection}
          />
        }
      />
      <Route
        path="/individual/account_type"
        element={
          <PrivateRoute
            path="/individual/account_type"
            component={IndividualAccountType}
          />
        }
      />
      <Route
        path="/individual/documentation"
        element={
          <PrivateRoute
            path="/individual/documentation"
            component={IndividualDocsRequired}
          />
        }
      />
      <Route
        path="/individual/status"
        element={
          <PrivateRoute
            path="/individual/status"
            component={IndividualDenied}
          />
        }
      />
      <Route
        path="/individual/change-email"
        element={
          <PrivateRoute
            path="/individual/change-email"
            component={IndividualDenied}
          />
        }
      />
      <Route
        path="/individual/attention"
        element={
          <PrivateRoute
            path="/individual/attention"
            component={IndividualDocsRequired}
          />
        }
      />

      {/* Apex has our documents url as /docs so just redirect to right route */}
      <Route
        path="/dashboard/docs"
        element={<Navigate to="/dashboard/documents" replace />}
      />
      <Route
        path="/docs"
        element={<Navigate to="/dashboard/documents" replace />}
      />

      <Route
        element={
          <PrivateRoute
            path="/dashboard"
            component={IndividualDashboardLayout}
          />
        }
      >
        {renderDashboardRoutes(dashboardRoutes)}
      </Route>
      <Route
        path="/verify-email"
        element={
          <PrivateRoute path="/verify-email" component={EmailVerification} />
        }
      />
      <Route
        path="/verify-email-redirect"
        element={
          <PrivateRoute
            path="/verify-email-redirect"
            component={EmailVerificationRedirect}
          />
        }
      />
      <Route
        path="/login"
        element={<PrivateRoute path="/login" component={IndividualLogin} />}
      />
      <Route
        path="/individual/setup_contribution"
        element={
          <PrivateRoute
            path="/individual/setup_contribution"
            component={SetupContribution}
          />
        }
      />
      <Route
        path="/link-bank"
        element={<PrivateRoute path="/link-bank" component={OauthPlaidLink} />}
      />
      <Route
        path="*"
        element={<PrivateRoute path="*" component={PageNotFound} />}
      />
    </Routes>
  );
};

export default IndividualRoutes;
